// shared/enums.js

// Staff categories
export const CATEGORY_OF_STAFF = [

  { value: 'Bank-HCA', label: 'Bank-HCA' },
  { value: 'Bank-RGN', label: 'Bank-RGN' },
  { value: 'ECT-HCA', label: 'ECT-HCA' },
  { value: 'Nurse', label: 'Registered Nurse' },
  { value: 'Doctor', label: 'Doctor / Consultant' },
  { value: 'HCA', label: 'Healthcare Assistant' },
  { value: 'AHP', label: 'Allied Health Professional' },
  { value: 'Admin', label: 'Administrative Staff' },
  { value: 'Other', label: 'Other' },
  { value: 'Testing', label: 'Testing' },
];




export const PRESHIFT_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

// Specials/Cohorts reason — shown when reasonForRequest is '1-1 special' or 'Cohorts'
export const SPECIALS_REASON = [
  { value: 'Absconsion risk-exit seeking', label: 'Absconsion risk-exit seeking' },
  { value: 'Behavioral',                   label: 'Behavioral' },
  { value: 'Confusion-Agitation ',          label: 'Confusion-Agitation' },
  { value: 'Delirium',                     label: 'Delirium' },  
  { value: 'Aggression-Violence',          label: 'Aggression-Violence' },  
  { value: 'Eating disorder',              label: 'Eating disorder' },
  { value: 'Alcohol-Detox',               label: 'Alcohol-Detox' },
  { value: 'BPSD',                         label: 'BPSD' },
  { value: 'Cohort',                       label: 'Cohort' },  
  { value: 'Falls Risk',                   label: 'Falls Risk' },
  { value: 'Psych',                        label: 'Psych' },
  { value: 'Risk to Self-Others',          label: 'Risk to Self-Others' },
  { value: 'Extra Capacity',          label: 'Extra Capacity' },
  { value: 'Safeguarding',          label: 'Safeguarding' },

  ];



// Reason for shift request
export const REASON_FOR_REQUEST = [
  { value: 'Vacancy', label: 'Vacancy' },
   { value: '1-1 special', label: '1-1 special' },
   { value: 'Cohorts', label: 'Cohorts' },
  { value: 'Sickness', label: 'Sickness' },
  { value: 'Short Notice', label: 'Short Notice' },
  { value: 'Planned Absence', label: 'Planned Absence' },
  { value: 'Increased Acuity', label: 'Increased Acuity' },
  { value: 'Study Leave', label: 'Study Leave' },
  { value: 'Parental Leave', label: 'Parental Leave' },
  { value: 'Force Majeure', label: 'Force Majeure' },
  { value: 'Bereavement Leave', label: 'Bereavement Leave' },
  { value: 'Maternity Leave', label: 'Maternity Leave' },
  { value: 'Annual Leave', label: 'Annual Leave' },
  { value: 'Paternity Leave', label: 'Paternity Leave' },
  { value: 'Parents Leave', label: 'Parents Leave' }, 
  { value: 'Extra Capacity', label: 'Extra Capacity' },
  { value: 'Other', label: 'Other' },
];

// Shift status
export const SHIFT_STATUS = [
  { value: 'Open', label: 'Open' },
  { value: 'Closed', label: 'Closed' },
  
];

// Line status
export const LINE_STATUS = [
  { value: 'Open', label: 'Open' },
  { value: 'On Hold', label: 'On Hold' },
  { value: 'Archived', label: 'Archived' },
   { value: 'FilledByStaff', label: 'FilledByStaff' },
   { value: 'FilledByAgency', label: 'FilledByAgency' },
   { value: 'Filled', label: 'Filled' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Complete', label: 'Complete' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Not Worked', label: 'Not Worked' },

];

// actual status
export const ACTUAL_STATUS = [
  { value: 'Open', label: 'Open' },
  { value: 'On Hold', label: 'On Hold' },
  { value: 'Archived', label: 'Archived' },
  { value: 'FilledByStaff', label: 'FilledByStaff' },
   { value: 'FilledByAgency', label: 'FilledByAgency' },
    { value: 'Filled', label: 'Filled' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Complete', label: 'Complete' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Not-Worked', label: 'Not-Worked' },
  

];

// Agency request Line status
export const AGENCY_REQUEST_LINE_STATUS = [
  { value: 'Open', label: 'Open' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Request-Sent', label: 'Request-Sent' }, 
  { value: 'shiftRequested', label: 'shiftRequested' },  

];

// Unavailability reasons (from StaffAvailability)
export const UNAVAILABILITY_REASONS = [
'Annual Leave',
'Adoptive Leave',
'Bereavement Leave',
'Carers Leave.',
'Certified Sick Leave',
'Force Majeure',
'Health and Safety Leave',
'Jury Leave',
'Maternity Leave',
'Other',
'Parents Leave',
'Parental Leave',
'Paternity Leave',
'Sick Leave',
'Study Leave / Mandatory Training',
];


// Utility: get only values for Mongoose enums
export const extractEnumValues = (array) => array.map((item) => item.value);
